import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import ImageEditor from '../../mini/ImageEditor'
import { getImageNameFromUrl } from '../../../utils/index'
import {
  removeIconImage,
  uploadImage,
  updateQuestImageSource
} from '../../../actions/quest'
import { saved, remove, save, sourceOfTheImage } from '../../../utils/messages'

export default class Images extends Component {
  constructor(props) {
    super(props)
    this.state = {
      questImage: props.quest.icon_image_url || '',
      questImageSource:
        props.quest.icon_image_license_properties.source_url || ''
    }
    this.onRemoveIconImageClickBound = this.onRemoveIconImageClick.bind(this)
    this.onSaveIconImageClickBound = this.onSaveIconImageClick.bind(this)
    this.onSaveImageSourceClickBound = this.onSaveImageSourceClick.bind(this)
    this.handleIconImageSourceChangeBound =
      this.handleIconImageSourceChange.bind(this)
  }

  componentDidUpdate(prevProps) {
    const { quest } = this.props

    if (
      quest.icon_image_url &&
      prevProps.quest.icon_image_url !== quest.icon_image_url
    ) {
      const _el = document.querySelector('.icon-saved')
      _el.classList.add('active')
      setTimeout(() => {
        _el.classList.remove('active')
      }, 3800)
    }

    if (
      quest.icon_image_url &&
      prevProps.quest.icon_image_license_properties.source_url !==
        quest.icon_image_license_properties.source_url
    ) {
      const _el = document.querySelector('.icon-url-saved')
      _el.classList.add('active')
      setTimeout(() => {
        _el.classList.remove('active')
      }, 3800)
    }
  }

  render() {
    const { quest, allowEdit } = this.props
    const questImageName = getImageNameFromUrl(
      quest.icon_image_original_file_name
    )

    return (
      <div className="images">
        <div className="quest-image">
          <div>
            <div className="title">
              <FormattedMessage
                id={'Quest.Images.QuestIcon'}
                defaultMessage={'Quest Icon'}
              />
              <div className="requiredtool" />
            </div>
            <div className="subtitle">
              <FormattedMessage
                id={'Quest.Images.ForBestViewingImage'}
                defaultMessage={
                  'For best viewing, please use a square image (png format) no larger than 200x200 pixels and file size no larger than 500 kb'
                }
              />
            </div>
            <div
              className={
                !quest.icon_image_url ? 'quest-image' : 'quest-image loaded'
              }
            >
              {allowEdit && (
                <div className="addmode">
                  <div className="cropper-wrapper icon">
                    <ImageEditor
                      height={200}
                      width={200}
                      borderRadius={100}
                      handleSaveImage={this.onSaveIconImageClickBound}
                    />
                  </div>
                </div>
              )}
              <label className="image-name">{questImageName}</label>
              <img id="icon" src={quest.icon_image_url} />
              {allowEdit && (
                <div className="saved-remove-container">
                  <div className={'button icon-saved saved'}>{saved}</div>
                  <div
                    className={`button remove-icon btn-destructive-small ${
                      quest.icon_image_url ? 'show' : ''
                    }`}
                    onClick={this.onRemoveIconImageClickBound}
                  >
                    {remove}
                  </div>
                </div>
              )}
              {allowEdit && quest.icon_image_url && (
                <div className="source-url-wrapper active">
                  <div className="title">{sourceOfTheImage}</div>
                  <input
                    type="text"
                    id="iconSourceUrl"
                    className="copyright-url form-control"
                    defaultValue={
                      quest.icon_image_license_properties.source_url
                    }
                    placeholder="http://"
                    onChange={this.handleIconImageSourceChangeBound}
                    accept="image/*"
                  />
                  <div className="button icon-url-saved saved">{saved}</div>
                  <div
                    className={`button save btn-primary-small ${
                      this.shouldSaveBeDisabled() ? 'disabled' : ''
                    }`}
                    id="iconSourceSave"
                    onClick={this.onSaveImageSourceClickBound}
                  >
                    {save}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  async onRemoveIconImageClick() {
    await this.props.dispatch(removeIconImage())
    this.setState(() => ({
      questImage: '',
      questImageSource: ''
    }))
  }

  onSaveIconImageClick(fileName, fileURL) {
    this.props.dispatch(uploadImage('icon', fileURL, fileName))
  }

  onSaveImageSourceClick(e) {
    this.props.dispatch(updateQuestImageSource(this.state.questImageSource))
  }

  handleIconImageSourceChange(e) {
    this.setState({ questImageSource: e.target.value })
  }

  shouldSaveBeDisabled() {
    const { questImageSource } = this.state
    const { quest } = this.props

    return (
      this.props.isSavingQuest ||
      ((quest.icon_image_license_properties.source_url === questImageSource ||
        Object.keys(quest.icon_image_license_properties).length === 0) &&
        questImageSource.length === 0)
    )
  }
}

Images.propTypes = {
  quest: PropTypes.object.isRequired,
  allowEdit: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  isSavingQuest: PropTypes.bool.isRequired
}



// WEBPACK FOOTER //
// ./src/components/quest/section/Images.js